module.exports = __webpack_public_path__ + "img/icon4.d24b4cd2.png";